import React, { useCallback, useEffect } from "react";
import HFNModalPopup from "sharedComponents/modalPopup";
import LoginPanel from "components/login/LoginPanel";
import modalPopup from "utils/modalPopup";
import { lStorage } from "utils/storage";
import { logout } from "utils/common";
import { userDoesNotExists } from "utils/login";

const SelectRole = () => {
  const loginUserRoles = lStorage.get("loginUserRoles");

  useEffect(() => {
    if (lStorage.get("loginUserRoles")) {
      modalPopup.custom({
        header: "Select Your Role",
        className: "login-popup",
        visible: true,
        draggable: false,
      });
    } else {
      userDoesNotExists();
    }
  }, [lStorage]);

  const closePanel = useCallback(async () => {
    await logout();
    modalPopup.toggle(false);
  }, []);

  return (
    <>
      {loginUserRoles?.loginUser ? (
        <HFNModalPopup>
          <LoginPanel
            closePanel={closePanel}
            roleList={loginUserRoles?.roles}
            loginUserRoles={loginUserRoles?.loginUser}
            user={loginUserRoles?.user}
            isLogin={true}
          />
        </HFNModalPopup>
      ) : null}
    </>
  );
};

export default SelectRole;
